/**
 * VenueStagePill — lifecycle stage chip (BON-157 stage enum). Port of the
 * design's NBStagePill. Maps each stage to an existing dashboards status-pill
 * tone; `dropped` gets a deliberately muted treatment (it's an end state).
 */
import type { CSSProperties } from 'react';

import type { VenueStage } from '../../../../api/venues';

interface StageMeta {
  label: string;
  /** nb-status-* class suffix, or 'dropped' for the muted treatment. */
  cls: string;
  hint: string;
}

export const VENUE_STAGES: Record<VenueStage, StageMeta> = {
  prospect: { label: 'Prospect', cls: 'open', hint: 'Being recruited — no workshop yet' },
  active: { label: 'Active', cls: 'ontrack', hint: 'First workshop booked' },
  home: { label: 'Bonsai Bar Home', cls: 'soldout', hint: 'Recurring cadence' },
  inactive: { label: 'Inactive', cls: 'soft', hint: 'Computed — no future events' },
  dropped: { label: 'Dropped', cls: 'dropped', hint: 'Deliberate stop, reason captured' },
};

export function VenueStagePill({ stage, size = 'md' }: { stage: VenueStage; size?: 'md' | 'lg' }) {
  const meta = VENUE_STAGES[stage];
  const dropped = meta.cls === 'dropped';
  const droppedStyle: CSSProperties = dropped
    ? { background: 'var(--nb-surface-2)', color: 'var(--nb-muted)', borderColor: 'transparent' }
    : {};
  return (
    <span
      className={`nb-pill ${dropped ? '' : `nb-status-${meta.cls}`}`}
      title={meta.hint}
      style={{
        height: size === 'lg' ? 24 : 20,
        fontSize: size === 'lg' ? 11.5 : 10.5,
        padding: '0 9px',
        ...droppedStyle,
      }}
    >
      <i className="nb-pill-dot" />
      {meta.label}
    </span>
  );
}
